import React from 'react';
import { fmtMoney } from '../utils/format';

const fmtDateTime = (s) => {
  if (!s) return '—';
  try {
    const d = new Date(s);
    const date = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true });
    return `${date}  ${time}`;
  } catch (_) { return s; }
};

const Receipt = ({ sale, items, payments, facility, branchName, cashier }) => {
  if (!sale) return null;

  const currency = facility?.currency || 'GHS';
  const hasDiscount = Number(sale.discount_amount) > 0;
  const hasTax      = Number(sale.tax_amount) > 0;
  const hasChange   = Number(sale.change_amount) > 0;

  return (
    <div className="rcpt">

      {/* ── Header: facility identity ── */}
      <div className="rcpt-header">
        <div className="rcpt-bizname">{(facility?.name || 'SHOP').toUpperCase()}</div>
        {facility?.tagline  && <div className="rcpt-tagline">{facility.tagline}</div>}
        {branchName         && <div className="rcpt-branch">{branchName.toUpperCase()}</div>}
      </div>

      {/* ── Contact details ── */}
      {(facility?.location || facility?.phone || facility?.email || facility?.digital_address) && (
        <div className="rcpt-contact">
          {facility?.location        && <div className="rcpt-contact-line">📍 {facility.location}</div>}
          {facility?.phone           && <div className="rcpt-contact-line">📞 {facility.phone}</div>}
          {facility?.email           && <div className="rcpt-contact-line">✉  {facility.email}</div>}
          {facility?.digital_address && <div className="rcpt-contact-line">🏷  {facility.digital_address}</div>}
        </div>
      )}

      <div className="rcpt-sep-solid" />

      {/* ── Transaction info ── */}
      <div className="rcpt-meta">
        <div className="rcpt-row"><span>Receipt No</span><span className="rcpt-bold">{sale.receipt_no}</span></div>
        <div className="rcpt-row"><span>Date</span>     <span>{fmtDateTime(sale.created_at)}</span></div>
        {cashier            && <div className="rcpt-row"><span>Cashier</span>  <span>{cashier}</span></div>}
        {sale.customer_name && <div className="rcpt-row"><span>Customer</span> <span>{sale.customer_name}</span></div>}
      </div>

      <div className="rcpt-sep-dash" />

      {/* ── Items ── */}
      <div className="rcpt-items-head">ITEMS</div>
      {items.map((it, i) => (
        <div key={i} className="rcpt-item">
          <div className="rcpt-item-name">{it.product_name}</div>
          <div className="rcpt-row rcpt-item-detail">
            <span className="rcpt-muted">{Number(it.qty)} × {fmtMoney(it.unit_price, '').trim()}</span>
            <span className="rcpt-bold">{fmtMoney(it.line_total, '').trim()}</span>
          </div>
        </div>
      ))}

      <div className="rcpt-sep-dash" />

      {/* ── Subtotals ── */}
      <div className="rcpt-subtotals">
        <div className="rcpt-row"><span>Subtotal</span><span>{fmtMoney(sale.subtotal, '').trim()}</span></div>
        {hasTax      && <div className="rcpt-row"><span>Tax</span>                          <span>{fmtMoney(sale.tax_amount, '').trim()}</span></div>}
        {hasDiscount && <div className="rcpt-row rcpt-discount"><span>Discount</span>       <span>- {fmtMoney(sale.discount_amount, '').trim()}</span></div>}
      </div>

      {/* ── Grand total ── */}
      <div className="rcpt-total-block">
        <div className="rcpt-total-row">
          <span>TOTAL</span>
          <span>{fmtMoney(sale.total_amount, currency)}</span>
        </div>
      </div>

      {/* ── Payments ── */}
      <div className="rcpt-payments">
        {payments.map((p, i) => (
          <div key={i} className="rcpt-row">
            <span>{String(p.method).toUpperCase()}{p.reference ? ` · ${p.reference}` : ''}</span>
            <span>{fmtMoney(p.amount, '').trim()}</span>
          </div>
        ))}
        {hasChange && (
          <div className="rcpt-row rcpt-change">
            <span>CHANGE</span>
            <span>{fmtMoney(sale.change_amount, '').trim()}</span>
          </div>
        )}
      </div>

      <div className="rcpt-sep-solid" />

      {/* ── Footer ── */}
      <div className="rcpt-footer">
        <div className="rcpt-thanks">Thank you for your patronage!</div>
        <div className="rcpt-sub">Akwaaba — please come again 🇬🇭</div>
        <div className="rcpt-policy">Goods sold are not returnable without this receipt.</div>
      </div>

    </div>
  );
};

export default Receipt;
